export enum PopinMode {
    Click = 'click',
    Hover = 'hover',
    Custom = 'custom',
}
